import { render } from "./OidoButton.vue?vue&type=template&id=e4039706&scoped=true"
import script from "./OidoButton.vue?vue&type=script&lang=js"
export * from "./OidoButton.vue?vue&type=script&lang=js"

import "./OidoButton.vue?vue&type=style&index=0&id=e4039706&scoped=true&lang=css"
import "./OidoButton.vue?vue&type=style&index=1&id=e4039706&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4039706"]])

export default __exports__